import React, { useEffect } from 'react';
import styled from 'styled-components';

type StoryLaneEmbedProps = {
  id: string;
  width?: number;
  height?: number;
};

const StoryLaneEmbed: React.FC<StoryLaneEmbedProps> = ({ id, width = 800, height = 450 }) => {
  const dimensionPadding = (height / width) * 100 + 3.125; // Adding 25px (3.125%) for Storylane controls

  useEffect(() => {
    // Load Storylane script if not already loaded
    if (!document.querySelector('script[src*="storylane.io"]')) {
      const script = document.createElement('script');
      script.src = 'https://js.storylane.io/js/v2/storylane.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  const embedCode = `<iframe class="sl-demo" loading="lazy" src="https://app.storylane.io/demo/${id}?embed=inline" name="sl-embed" allow="fullscreen" allowfullscreen style="position:absolute;top:0;left:0;width:100%!important;height:100%!important;border:1px solid rgba(63,95,172,0.35);box-shadow: 0px 0px 18px rgba(26, 19, 72, 0.15);border-radius:10px;box-sizing:border-box;"></iframe>`;

  return <EmbedStyled padding={dimensionPadding} dangerouslySetInnerHTML={{ __html: embedCode }} />;
};

type EmbedStyleProps = {
  padding: number;
};

const EmbedStyled = styled.div<EmbedStyleProps>`
  width: 100%;
  position: relative;
  padding-bottom: ${(props) => props.padding}%;
  height: 0;
  overflow: hidden;
  margin: 1.5rem 0;
  transform: scale(1);

  iframe,
  object,
  embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

export default StoryLaneEmbed;
